import logo from './logo.svg';
import './App.css';
import { Routes, Route, useParams } from "react-router-dom"
import { art_projects, client_projects } from "./projects.js"
import React from 'react';
import {useEffect, useState} from "react";
import Draggable from 'react-draggable'; // The default

const Info = () => {


  return (
<div className="info">
  I'm a creative technologist currently studying...
    </div>
  );
}

export default Info;
